import NativeFlex from 'components/NativePost/Bits/NativeFlex';
import { getNativeColor } from 'components/NativePost/Helpers';
import styled, { css } from 'components/_UI/designSystem';
import { theme } from '../constants';
import { getLineClamp } from '../nativeText/styledComponents';
import { StyledTextProps } from '../types';

export const StyledEmoji = styled.img`
    vertical-align: middle;
`;

export const StyledNativeTitle = styled(NativeFlex)<StyledTextProps>`
    ${({ colorMode }) =>
        css`
            color: ${getNativeColor(theme, colorMode, 'text')};
        `}
    ${StyledEmoji} {
        height: 1em;
        width: 1em;
    }

    font-size: 1.3em;
    font-weight: 650;
    line-height: 1.2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
    ${props => getLineClamp(props.lineClamp)}
`;
